import { omit } from 'lodash';
import { convertToRaw, EditorState } from 'draft-js';

import { QTask, SelectOption, QTaskTag } from '@qwealth/qdata';
import { getTagKeys } from 'data/helpers/taskHelper';
import { sortStringsAlphabetically } from 'data/helpers/data';

export type QTaskForm = Omit<QTask, 'householdQID' | 'assignee'> & {
  pending?: Array<File>;
  assignee?: SelectOption<string> | string | null;
  householdQID?: string | null;
  tags: string[];
  tagsFromWorkflow?: string[];
};

export const getCurrentUserTags = (taskTags: QTaskTag[] | undefined, currentUserPartnerId: number): QTaskTag[] => {
  return taskTags?.filter(tag => tag.partnerId === currentUserPartnerId) || [];
};

export const getCurrentUserTagsKey = (taskTags: QTaskTag[] | undefined, currentUserPartnerId: number): string[] => {
  const userTagsKey = getTagKeys(getCurrentUserTags(taskTags, currentUserPartnerId));
  return userTagsKey;
};

export const getOtherUsersTags = (taskTags: QTaskTag[] | undefined, currentUserPartnerId: number): QTaskTag[] => {
  return taskTags?.filter(tag => tag.partnerId !== currentUserPartnerId) || [];
};

export const toQTask = (rawValues: QTaskForm, editorState?: EditorState): QTask => {
  let assignee = typeof rawValues.assignee === 'string' ? rawValues.assignee : '';
  if (typeof rawValues.assignee === 'object' && rawValues.assignee && 'value' in rawValues.assignee) {
    assignee = (rawValues.assignee as SelectOption<string>).value;
  }

  const newValues: QTask = { ...omit(rawValues, ['householdName', 'householdType', 'pending', 'tags']), assignee };

  if (editorState) {
    newValues.details = JSON.stringify(convertToRaw(editorState.getCurrentContent()));
  }

  return newValues;
};
